import { Row, message } from "antd";
import { Button, Form, Input, Modal, Select, Tooltip } from "antd/es";
import React, { useCallback, useEffect, useState } from "react";
import { useValidWarehouse, useWarehouse } from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import ShipOrders from "./ShipOrders";

const { Option } = Select;

const WarehouseModal = ({
  caseId,
  orderId,
  isModalVisible,
  setModalVisible,
  refreshUi = null,
  data,
}) => {
  const [form] = Form.useForm();
  const [orderStatus, setOrderStatus] = useState("");
  const [markShipped, setMarkShipped] = useState(false);
  const [currentWarehouse, setCurrentWarehouse] = useState("");
  const [selectedWarehouse, setSelectedWarehouse] = useState("");
  const [warehouses, setWarehouses] = useState([]);
  const [updatingWarehouse, setUpdatingWarehouse] = useState(false);
  const [buttonDisaled, setButtonDisaled] = useState(false);
  const [tooltip, setTooltip] = useState("");
  const [trackingId, setTrackingId] = useState("");
  const [trackingUrl, setTrackingUrl] = useState("");
  const { setToaster } = useToast();
  const {
    warehouseData,
    updatedWarehouseData,
    fetchWarehouseData,
    updateWarehouse,
  } = useWarehouse();
  const { validWarehouseData, fetchValidWarehouseData } = useValidWarehouse();

  const validWarehouse = useCallback(async (orderId) => {
    const isValidWarehouse = await fetchValidWarehouseData(orderId);
    if (validWarehouseData) {
      setOrderStatus(validWarehouseData?.orderStatus);
      if (validWarehouseData.isValid) {
        setCurrentWarehouse(validWarehouseData?.name);
        setSelectedWarehouse(validWarehouseData?.name);
      }
    }
  }, []);

  useEffect(() => {
    if (warehouseData) {
      let warehouses = warehouseData.map((el) => ({
        label: el.name,
        value: el.code,
      }));
      setWarehouses(warehouses);
    }
  }, [warehouseData]);

  const _getAllWarehouses = async () => {
    let warehouses = await fetchWarehouseData();
  };

  useEffect(() => {
    if (isModalVisible) validWarehouse(orderId);
    return () => {
      setCurrentWarehouse("");
      setSelectedWarehouse("");
    };
  }, [orderId, isModalVisible, validWarehouse]);

  useEffect(() => {
    if (isModalVisible) _getAllWarehouses();
  }, [isModalVisible]);

  const handleWarehouseUpdate = async () => {
    setUpdatingWarehouse(true);
    const updatedData = JSON.stringify({
      orderId: orderId,
      locationCode: selectedWarehouse,
      trackingUrl: trackingUrl ? trackingUrl : data.tracking_url,
      trackingId: trackingId ? trackingId : data.tracking_id,
    });
    const temp = await updateWarehouse(updatedData, setToaster);
    setUpdatingWarehouse(false);
    setModalVisible(false);
  };

  const handleMarkShipModal = () => {
    setMarkShipped(false);
    setModalVisible(false);
    if (refreshUi) refreshUi();
  };

  const getTooltip = useCallback(() => {
    if (["delivered", "shipped"].includes(orderStatus)) {
      setButtonDisaled(true);
      setTooltip(`Order already ${orderStatus}`);
    } else if (!currentWarehouse) {
      setButtonDisaled(true);
      setTooltip("Warehouse info not updated");
    } else if (currentWarehouse !== selectedWarehouse) {
      setButtonDisaled(true);
      setTooltip("Update the warehouse before mark order shipped");
    } else {
      setButtonDisaled(false);
      setTooltip("Mark order shipped if warehouse info is correct");
    }
  }, [currentWarehouse, orderStatus, selectedWarehouse]);

  useEffect(() => {
    getTooltip();
  }, [getTooltip]);

  if (markShipped) {
    return (
      <ShipOrders
        isModalVisible={markShipped}
        orderId={orderId}
        setIsModalVisible={() => handleMarkShipModal()}
        caseId={caseId}
      />
    );
  } else {
    return (
      <div>
        <Modal
          title="Warehouse info"
          visible={isModalVisible}
          onCancel={() => {
            setModalVisible(false);
            setSelectedWarehouse("");
          }}
          footer={[
            <Button
              key="cancel"
              onClick={() => {
                setModalVisible(false);
                setSelectedWarehouse("");
              }}
            >
              Cancel
            </Button>,
            // <Button
            // 	disabled={updatingWarehouse}
            // 	// key="continue"
            // 	// type="default"
            // 	type="primary"
            // 	htmlType="submit"
            // 	onClick={handleWarehouseUpdate}>
            // 	Update Warehouse
            // </Button>,

            <Tooltip placement="topLeft" title={tooltip}>
              <Button
                className="ml-2"
                key="continue"
                type="primary"
                disabled={buttonDisaled}
                onClick={() => setMarkShipped(true)}
              >
                Mark Shipped
              </Button>
            </Tooltip>,
          ]}
        >
          <p>Current warehouse: {currentWarehouse || "None"}</p>
          <Form form={form} layout="vertical" onFinish={handleWarehouseUpdate}>
            <Form.Item
              // label="Assign To"
              name="select_warehouse"
              rules={[{ required: true, message: "Please select this" }]}
            >
              <Select
                style={{ width: "100%" }}
                value={selectedWarehouse}
                onChange={(value) => setSelectedWarehouse(value)}
              >
                {warehouses.map((el) => (
                  <Option value={el.value}>{el.label}</Option>
                ))}
              </Select>
            </Form.Item>
            <Row className="mt-4" style={{ width: "100%" }}>
              <Form.Item
                label="Tracking URL"
                name="trackingUrl"
                rules={[
                  {
                    required: data ? false : true,
                    message: "Please fill this",
                  },
                ]}
              >
                <Input
                  placeholder="Enter URL"
                  style={{ width: 450 }}
                  onChange={(e) => setTrackingUrl(e.target.value)}
                  defaultValue={data ? data.tracking_url : ""}
                />
              </Form.Item>
              <Form.Item
                label="Traking ID"
                name="trackingId"
                rules={[
                  {
                    required: data ? false : true,
                    message: "Please fill this",
                  },
                ]}
              >
                <Input
                  placeholder="Enter Tracking Id"
                  style={{ width: 450 }}
                  onChange={(e) => setTrackingId(e.target.value)}
                  defaultValue={data ? data.tracking_id : ""}
                />
              </Form.Item>
            </Row>
            <Form.Item className="text-center">
              <Button
                disabled={updatingWarehouse}
                type="primary"
                htmlType="submit"
              >
                Update Warehouse
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    );
  }
};

export default WarehouseModal;
